import tw from 'tailwind-styled-components'
import {AnyColor} from '@components/common/base/design-system'

export const Overlay = tw.div<{
  position?: 'fixed' | 'absolute'
  bgColor?: AnyColor
}>`
    z-2000
    fixed
    top-0 
    bottom-0 
    left-0 
    right-0
    ${({bgColor}) => `bg-${bgColor}` || 'bg-transparent'}
    ${({position}) => position || 'fixed'}
`
